export default [
  {
    path: '/subscription/products',
    name: 'subscription-products',
    meta: {
      title: '訂閱服務-商品列表',
      auth: true
    },
    component: () => import('@/views/subscription/products.vue'),
    beforeEnter: (to, from, next) => {
      // fix ios old version sdk invalid token issue
      if (to?.query?.token && to.query.token.indexOf('?') !== -1) {
        const { token: _token, ...otherQuery } = to.query
        const replaceQuery = 'token=' + String(_token).replaceAll('?', '&')

        // matomo trackEvent url_replace_token_issue
        window?._paq?.push(['trackEvent', 'Accident', 'Subscription Products beforeEnter', 'Invalid Token in URL Query'])

        return next({
          path: to.path + '?' + replaceQuery,
          replace: true,
          query: otherQuery
        })
      }
      next()
    }
  },
  {
    path: '/subscription/checkout/:id',
    name: 'subscription-checkout',
    meta: {
      title: '訂閱服務-確認購買',
      auth: true
    },
    component: () => import('@/views/subscription/checkout.vue')
  },
  {
    path: '/subscription/my-subscriptions',
    name: 'my-subscriptions',
    meta: {
      title: '我的訂閱',
      auth: true
    },
    component: () => import('@/views/subscription/my-subscriptions.vue')
  },
  {
    path: '/subscription/detail/:id',
    name: 'subscription-detail',
    meta: {
      title: '訂閱詳情',
      auth: true
    },
    component: () => import('@/views/subscription/detail.vue')
  },
  {
    path: '/subscription/daily-rewards',
    name: 'subscription-daily-rewards',
    meta: {
      title: '每日獎勵',
      auth: true
    },
    component: () => import('@/views/subscription/daily-rewards.vue')
  },
  {
    path: '/subscription/coin-history',
    name: 'subscription-coin-history',
    meta: {
      title: '金幣歷史',
      auth: true
    },
    component: () => import('@/views/subscription/coin-history.vue')
  },
  {
    path: '/subscription/purchase-result',
    name: 'subscription-purchase-result',
    meta: {
      title: '訂閱購買結果',
      auth: true
    },
    component: () => import('@/views/subscription/purchase-result.vue')
  }
]